<template>
	<!--团队-->
	<div class="box">
		<div class="joinedComposition">
			<div class="header">
				<div class="fl">
					<i class="" style="cursor: pointer;" @click="fhFn(false)"></i>
					<span></span>
					<span>桌面软件</span>
				</div>
				<div v-show="mzglBool">
					<div>
						
					</div>
				</div>
			</div>
			<div class="content_user">
				<div class="fl">
					<div class="navMenuTd active" @click="tabClick('1',$event)">
						<span>使用概况</span>
						<i class=""></i>
					</div>
					<div class="navMenuTd" @click="tabClick('2',$event)">
						<span>审阅与分享</span>
						<i class=""></i>
					</div>
					<div class="navMenuTd" @click="tabClick('3',$event)">
						<span>有效与活跃</span>
						<i class=""></i>
					</div>
				</div>
				<div>
					<div v-if="mokuai==1">
						<execharts></execharts>
					</div>
					<div v-if="mokuai==2">
						<fxecharts></fxecharts>
					</div>
					<div v-if="mokuai==3">
						<hyecharts></hyecharts>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import { mapState,mapMutations} from 'vuex'
	
	import execharts from '../../../component/exEchart.vue'
	import fxecharts from '../../../component/fxEcharts.vue'
	import hyecharts from '../../../component/hyecharts.vue'
	export default{
		components:{
			execharts,
			fxecharts,
			hyecharts
		},
		data(){
			return{
				companysrow:{},
				csVal:'',
				glList:[],
				drList:[],
				atList:[],
				addCyBool:false,
				tdlist:[],
				tel:'',
				xxgsVal:false,
				sqVal:true,
				nameVal:'',
				zspwdVal:'',
				addressVal:'',
				lxtel:'',
				gfwzVal:'',
				vxVal:'',
				ylImg:'',
				yyImg:'',
				sList:[],
				sheng:'',
				shiList:[],
				shi:'',
				xianList:[],
				xian:'',
				glyName:'',
				usersetBool:false,
				mrImg:'http://api.bats-bio.com/upload/2019-10-23/5dafbb3a5a2f6.png',
				yyxkImg:false,
				yyzzImg:false,
				mzglBool:false,
				cyglBool:false,
				szczBool:false,
				minname:'',
				xiugaiqueding:false,
		    	deleUser:[],
		    	lxdhval:'',
		    	centerDialogVisible:false,
				DialogImg:'',
				thiscpyId:this.cpyId,
				setglyBool:false,
				uNameGly:'',
				uIdGly:'',
				sqList:[],
				xxgsRz:'',
				lxdhvalqh:'',
				lxdhvalhm:'',
				cIsRZ:'',
				dialoggrzyBool:false,
				wsdaqBool:false,
				tiuchuzhensuoBool:false,
				mokuai:1
			}
		},
		created(){
//			this.chengshiFn();
		},
		mounted(){
//			this.companys_rowFn();
		},
		methods:{
			 move(e){
	            let odiv = e.target;  
	            let disX = e.clientX - odiv.offsetLeft;
	            let disY = e.clientY - odiv.offsetTop;
	            document.onmousemove = (e)=>{    
	                let left = e.clientX - disX;    
	                let top = e.clientY - disY;
                	odiv.style.left = left + 'px';
                	odiv.style.top = top + 'px';
	            };
	            document.onmouseup = (e) => {
	                document.onmousemove = null;
	                document.onmouseup = null;
	            };
		    },
			
			
			
			fhFn(bol){
				this.$emit('getMessage', bol)
			},
			imgCloseFn(){
				this.yyzzImg=false;
				this.yyxkImg=false;
			},
			
			up(a,b){
				return a.uTypeID-b.uTypeID
			},
			deleteFn(id){
				var data={
					cpy_id:this.companysrow.id,
					uid:id
				}
				users_delete_from_company(data).then(res=>{
//					console.log(res.data)
				})
			},
			setglyFn(){
				var data={
					uid:this.uIdGly,
					cpy_id:this.companysrow.id,
					zt:1
				}
				set_dual_status(data).then(res=>{
					this.$message({
			            type: 'success',
			            message: '设置成功',
						duration: 1000,
			            onClose: () => {
							this.setglyBool=false;
							this.glListFn();
						}
			        });
				})
			},
			remoreArr(id,event,typeid){
				for(var i=0;i<this.deleUser.length;i++){
					if(this.deleUser[i]==id){
						this.deleUser.splice(1,1);
						var el = event.currentTarget; 
						$(el).hide();
						$(el).siblings('.el-icon-delete-solid').show();
					}
				}
			},
		    tabClick(str,el){
				var el = event.currentTarget; 
				$(el).addClass('active').siblings().removeClass('active')
				this.mokuai=str;
			},
		},
		computed: {
			...mapState(['is_two','login_id'])
		},
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height:836px;
	}
	.notJoined{
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.notJoined>div{
		width:299px;
		height:274px;
		padding:0 40px;
		background:rgba(255,255,255,1);
		box-shadow:0px 0px 12px 0px rgba(0,0,0,0.13);
		border-radius:8px;
		margin-top: -100px;
	}
	.notJoined>div>div:nth-child(2){
		font-size:14px;
		font-family:PingFangSC;
		font-weight:400;
		color:rgba(0,0,0,1);
		line-height:20px;
		margin-bottom: 60px;
		margin-top: 90px;
	}
	.notJoined>div:nth-child(1)>div:nth-child(3)>button{
		width:299px;
		height:35px;
		background:rgba(176,176,176,1);
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border-radius:3px;
		font-size:11px;
		font-family:PingFangSC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:16px;
	}
	.notJoined>div:nth-child(2)>div:nth-child(3)>button{
		width:299px;
		height:35px;
		background:rgba(0,120,255,1);
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border-radius:3px;
		font-size:11px;
		font-family:PingFangSC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:16px;
	}
	.myJoined,.joinedComposition{
		width: 100%;
		height:836px;
		background:rgba(255,255,255,1);
		box-shadow:2px 2px 2px 0px rgba(119,151,178,0.16);
	}
	.header{
		width:100%;
		height:72px;
		background:rgba(255,255,255,1);
		box-shadow:0px 2px 2px 0px rgba(119,151,178,0.16);
		z-index: 90;
		position: relative;
		overflow: hidden;
	}
	.header>div:nth-child(1){
		width:255px;
		height: 100%;
		float: left;	
		position: absolute;
		display: flex;
		align-items: center;
	}
	.header>div:nth-child(1)>i{
		margin-left: 23px;
		margin-right: 12px;
		display: block;
		width:7px;
		height:13px;
		background:url(../../../assets/image/left.png) no-repeat center center;
		background-size:100% ;
	}
	.header>div:nth-child(1)>i:hover{
		margin-left: 21px;
		margin-right: 12px;
		display: block;
		cursor: pointer;
		width:9px;
		height:15px;
		background:url(../../../assets/image/left.png) no-repeat center center;
		background-size:100% ;
	}
	.header>div:nth-child(1)>span:nth-child(2){
		font-size:18px;
		font-family:PingFangSC;
		color:rgba(155,155,155,1);
		line-height:68px;
	}
	.header>div:nth-child(1)>span:nth-child(3){
		font-size:18px;
		font-family:PingFangSC;
		color:rgba(74, 74, 74, 1);
		line-height:68px;
	}
	.header>div:nth-child(2){
		margin-left: 130px;
		height: 100%;
	}
	.header>div:nth-child(2)>div:nth-child(1){
		width: 100%;
	}
	.content_user{
		width:100%;
		height:760px;
		background:RGBA(235, 235, 235, 1);
		overflow: hidden;
	}
	.joinedList>div{
		width:216px;
		height:118px;
		background:rgba(255,255,255,.7);
		border-radius:3px;
		font-size:14px;
		font-family:PingFangSC;
		font-weight:500;
		color:rgba(74,74,74,1);
		text-align: center;
		line-height: 118px;
		margin: 10px 0;
	}
	.content_user>div.fl{
		width:206px;
		height:760px;
		background:#F6F6F6;
		box-shadow:2px 0px 4px 0px rgba(155,155,155,0.23);
		position: absolute;
		z-index: 999;
	}
	.content_user>div:nth-child(2){
		margin-left: 206px;		
	}
	.content_user>div:nth-child(2)>div{
		padding: 10px;
	}
	.navMenuTd:nth-child(1){
		z-index: 999;
		padding-top:0px;
		margin-top: 0px;
	}
	.navMenuTd:nth-child(2){
		z-index: 998;
	}.navMenuTd:nth-child(3){
		z-index: 997;
		
	}
	.navMenuTd{
		width:206px;
		height:50px;
		padding-top:10px;
		margin-top: -10px;
		background:rgba(246,246,246,1);
		box-shadow:0px 2px 4px 0px rgba(155,155,155,0.4);
		border-radius:0px 0px 15px 0px;
		cursor: pointer;
		line-height:50px;
		position: relative;
		margin-bottom: 5px;
	}
	.navMenuTd>span{
		font-size:14px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:600 !important;
		color:rgba(74,74,74,1);
		margin-left: 15px;
	}
	.navMenuTd:nth-child(1)>i{
		top: 19px;
	}
	.navMenuTd>i{
		display: block;
		width:7px;
		height:13px;
		background: url(../../../assets/image/navMenuTd.png) no-repeat center center;
		background-size:100% ;
		position: absolute;
		right: 40px;
		top: 29px;
		/*transition: .3s all;*/
	}
	.navMenuTd:hover{
		background: #FFFFFF;
	}
	.navMenuTd:hover span{
		color:#3B97FF ;		
		
	}
	.navMenuTd:hover i{
		background: url(../../../assets/image/navMenuTdActive.png) no-repeat center center;
		background-size:100% ;
	}
	.navMenuTd.active{
		background: #FFFFFF;
		
	}
	.navMenuTd.active>span{
			color:#3B97FF ;		
	}
	.navMenuTd.active>i{
		background: url(../../../assets/image/navMenuTdActive.png) no-repeat center center;
		background-size:100% ;
	    transform: rotate(90deg);
	    transition: .3s all;
	}
	i.active{
		display: block;
		width:14px;
		height:14px;
		float: left;
		border-radius: 50%;
		margin-right: 3px;
		background: rgba(0, 120, 255, 1);
	}
</style>

<style type="text/css">
	.comClass2 .el-upload{
		width:177px;
		height:130px;
	}
	.el-dialog--center .el-dialog__body{
		text-align: center;
	}
</style>
<!---->


// WEBPACK FOOTER //
// src/components/MA/dateA/desktopExe.vue